import React from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "es", label: "ES", flag: "/assets/flags/es.png" },
  { code: "en", label: "EN", flag: "/assets/flags/en.png" },
  { code: "ru", label: "RU", flag: "/assets/flags/ru.png" },
  { code: "zh", label: "ZH", flag: "/assets/flags/zh.png" }
];

export default function LanguageSelector() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="absolute top-4 right-4 flex gap-3 z-50">
      {languages.map((lng) => (
        <button
          key={lng.code}
          onClick={() => changeLanguage(lng.code)}
          className="w-10 h-10 rounded-full p-[2px] bg-white/10 hover:bg-white/20 transition border border-white/30 shadow-[0_0_10px_#00E6FF]"
        >
          <img
            src={lng.flag}
            alt={lng.label}
            className="w-full h-full rounded-full object-cover"
          />
        </button>
      ))}
    </div>
  );
}
